// ═══════════════════════════════════════════════════════════════════════════
// ORE DEI RAPPORTINI PER OPERATORE (ottobre 2026)
// ═══════════════════════════════════════════════════════════════════════════
// Nexiora è per molte aziende diverse: un rapportino deve dire SENZA AMBIGUITÀ quante ore
// ha lavorato ciascun operatore. Per questo ogni operatore ha le sue ore (orePerOperatore),
// precompilate con la durata dell'intervento (ora fine − ora inizio) e modificabili.
//
// Rapportini nati prima (senza ore per operatore): le ore si ricavano da "ore" se esiste,
// altrimenti dalla durata ora inizio → ora fine, e si leggono secondo l'impostazione
// dell'organizzazione "rapportiniOrePrecedenti":
//   • "durata" (predefinita) → ogni operatore ha lavorato per tutta la durata;
//   • "totale"               → il numero è il totale, da dividere tra gli operatori.
// NB: prima di questa modifica, con fonte ore "Rapportini" la manodopera risultava sempre
// zero: i rapportini non salvavano un campo "ore" e il calcolo lo cercava.
// ═══════════════════════════════════════════════════════════════════════════
import { numIt } from "./economiaCommessa";

/** Ore tra due orari "HH:MM" (oltre la mezzanotte se la fine è prima dell'inizio). */
export function durataOre(oraInizio, oraFine) {
  const m = (s) => { const x = String(s || "").match(/^(\d{1,2}):(\d{2})/); return x ? Number(x[1]) * 60 + Number(x[2]) : null; };
  const a = m(oraInizio), b = m(oraFine);
  if (a === null || b === null) return 0;
  const diff = b >= a ? b - a : b + 24 * 60 - a;
  return Math.round((diff / 60) * 100) / 100;
}

/**
 * Ore per operatore di un rapportino: [{ uid, nome, ore }].
 * @param r rapportino
 * @param modoPrecedenti "durata" | "totale" (solo per i rapportini senza ore per operatore)
 */
export function orePerOperatoreRapportino(r, modoPrecedenti = "durata") {
  const nomi = r?.operatori || [];
  const uids = r?.operatoriUid || [];
  const n = Math.max(nomi.length, uids.length);
  const persone = Array.from({ length: n }, (_, i) => ({ uid: uids[i] || "", nome: nomi[i] || "" }))
    .filter(p => p.uid || p.nome);
  if (!persone.length) return [];
  const per = r?.orePerOperatore;
  if (per && typeof per === "object" && Object.keys(per).length) {
    return persone.map(p => ({ ...p, ore: numIt(per[p.uid || p.nome]) }));
  }
  const base = numIt(r?.ore) > 0 ? numIt(r.ore) : durataOre(r?.oraInizio, r?.oraFine);
  if (base <= 0) return persone.map(p => ({ ...p, ore: 0 }));
  const ore = modoPrecedenti === "totale" ? base / persone.length : base;
  return persone.map(p => ({ ...p, ore }));
}
